export default {"src":"/uk/_next/static/media/lightGreyInfoIcon.a5895613.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};